/* RynoPrints Shopify theme — shared behavior.
 * Converted from the static site's main.js + shop.js:
 *   - localStorage cart  →  Shopify Ajax Cart API (/cart/add.js, /cart/change.js, /cart.js)
 *   - catalog.js data    →  server-rendered cards with data-* attributes + JSON payloads
 * Progressive enhancement: forms and links all work with JS off; this layer
 * adds the drawer, instant filters, quick view, and toasts. No dependencies.
 */
(function () {
  "use strict";

  var settings = window.theme || {};
  var FREE_SHIP_THRESHOLD = settings.freeShipThreshold || 3500; // cents
  var routes = settings.routes || { cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change" };
  var strings = settings.strings || {};

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = settings.moneyFormat || "${{amount}}";
    var amount = (cents / 100).toFixed(2);
    if (/amount_no_decimals/.test(format)) amount = Math.round(cents / 100).toString();
    // Trim ".00" for the clean price look the static site used
    amount = amount.replace(/\.00$/, "");
    return format
      .replace(/\{\{\s*amount[^}]*\}\}/, amount)
      .replace(/<[^>]+>/g, "")
      .trim();
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str == null ? "" : String(str);
    return div.innerHTML;
  }

  /* ---------- toast ---------- */
  var toastEl = document.createElement("div");
  toastEl.className = "toast";
  toastEl.setAttribute("role", "status");
  document.body.appendChild(toastEl);
  var toastTimer;
  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("show"); }, 2600);
  }

  /* ---------- mobile nav ---------- */
  var menuToggle = $(".menu-toggle");
  var mobileMenu = $(".mobile-menu");
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", function () {
      var open = mobileMenu.classList.toggle("open");
      menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ================================================================
     Cart — Shopify Ajax Cart API
     ================================================================ */
  var drawer = $("[data-cart-drawer]");

  function request(url, payload) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          var err = new Error(json.description || json.message || "Cart error");
          err.data = json;
          throw err;
        }
        return json;
      });
    });
  }

  function getCart() {
    return fetch(routes.cart + ".js", { headers: { "Accept": "application/json" } })
      .then(function (res) { return res.json(); });
  }

  function addToCart(variantId, quantity, properties) {
    var payload = { id: variantId, quantity: quantity || 1 };
    if (properties) payload.properties = properties;
    return request(routes.cartAdd + ".js", payload);
  }

  function changeLine(lineKey, quantity) {
    return request(routes.cartChange + ".js", { id: lineKey, quantity: quantity });
  }

  function updateBadge(cart) {
    $all("[data-cart-count]").forEach(function (badge) {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    });
  }

  function updateShipProgress(root, cart) {
    var wrap = $("[data-ship-progress]", root) || (root && root.matches && root.matches("[data-ship-progress]") ? root : null);
    if (!wrap) return;
    var msg = $(".ship-progress-msg", wrap);
    var bar = $(".ship-bar span", wrap);
    if (!msg || !bar) return;
    if (cart.total_price >= FREE_SHIP_THRESHOLD) {
      msg.innerHTML = strings.freeShipUnlocked || "🎉 <strong>You've unlocked free shipping!</strong>";
      bar.style.width = "100%";
    } else {
      var remaining = formatMoney(FREE_SHIP_THRESHOLD - cart.total_price);
      var template = strings.freeShipRemaining || "Add <strong>[amount]</strong> more for free shipping";
      msg.innerHTML = template.replace("[amount]", remaining);
      bar.style.width = Math.round((cart.total_price / FREE_SHIP_THRESHOLD) * 100) + "%";
    }
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var itemsEl = $("[data-cart-items]", drawer);
    if (itemsEl) {
      if (!cart.items.length) {
        itemsEl.innerHTML = '<p class="cart-empty">' + (strings.cartEmpty || "Your cart is empty.") + "</p>";
      } else {
        itemsEl.innerHTML = cart.items.map(function (item) {
          var variantLine = item.product_has_only_default_variant ? "" :
            "<span>" + escapeHtml(item.variant_title || "") + "</span>";
          var img = item.image
            ? '<img class="cart-item-img" src="' + item.image.replace(/(\.[a-z]{3,4})(\?|$)/, "_120x$1$2") + '" alt="" width="60" height="60" loading="lazy">'
            : "";
          return (
            '<div class="cart-item">' + img +
              '<div class="cart-item-info"><strong>' + escapeHtml(item.product_title) + "</strong>" + variantLine +
                "<span>" + formatMoney(item.final_price) + "</span></div>" +
              '<div class="qty-controls">' +
                '<button type="button" data-line-dec="' + item.key + '" aria-label="Decrease quantity">−</button>' +
                "<span>" + item.quantity + "</span>" +
                '<button type="button" data-line-inc="' + item.key + '" aria-label="Increase quantity">+</button>' +
              "</div>" +
            "</div>"
          );
        }).join("");
      }
    }
    $all("[data-cart-total]").forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    updateShipProgress(drawer, cart);
    updateBadge(cart);
    // Cart page shares the ship-progress + totals markup
    var cartPage = $(".cart-page");
    if (cartPage) updateShipProgress(cartPage, cart);
  }

  function refreshCart() { return getCart().then(renderDrawer); }

  function openCart() {
    if (!drawer) return;
    drawer.classList.add("open");
    refreshCart();
  }
  function closeCart() { if (drawer) drawer.classList.remove("open"); }

  function findLineQuantity(cart, key) {
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].key === key) return cart.items[i].quantity;
    return 0;
  }

  function bumpLine(key, delta) {
    getCart().then(function (cart) {
      var next = findLineQuantity(cart, key) + delta;
      if (next < 0) next = 0;
      return changeLine(key, next);
    }).then(function (cart) {
      renderDrawer(cart);
      // On the cart page a full re-render keeps the table/line totals honest
      if (document.body.contains($(".cart-page-form"))) window.location.reload();
    }).catch(function (err) { toast(err.message); });
  }

  /* ---------- Ajax product forms (product page, standard products) ---------- */
  $all("form[data-ajax-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var variantId = parseInt(form.querySelector("[data-variant-id]").value, 10);
      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var btn = form.querySelector("[data-add-button]");
      if (btn) btn.disabled = true;
      addToCart(variantId, qty)
        .then(function () { return getCart(); })
        .then(function (cart) {
          renderDrawer(cart);
          toast(strings.addedToCart || "Added to cart");
          openCart();
        })
        .catch(function (err) {
          var msg = $("[data-form-msg]", form);
          if (msg) { msg.textContent = err.message; msg.className = "form-msg err"; }
          toast(err.message || strings.addError || "Couldn't add to cart");
        })
        .then(function () { if (btn) btn.disabled = false; });
    });
  });

  /* ---------- variant picker ---------- */
  $all("[data-variant-picker]").forEach(function (picker) {
    var jsonEl = $("[data-variants-json]", picker);
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var form = picker.closest("form");
    var idInput = form && form.querySelector("[data-variant-id]");
    var priceWrap = $("[data-price-wrapper]");
    var button = form && (form.querySelector("[data-add-button]") || form.querySelector('button[type="submit"]'));

    function currentOptions() {
      return $all("select[data-option-index]", picker).map(function (s) { return s.value; });
    }

    picker.addEventListener("change", function () {
      var opts = currentOptions();
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.join("||") === opts.join("||")) { match = variants[i]; break; }
      }
      if (!match) {
        if (button) { button.disabled = true; button.textContent = "Unavailable"; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceWrap) priceWrap.innerHTML = '<span class="price">' + formatMoney(match.price) + "</span>";
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? "Add to Cart" : "Sold Out";
      }
    });
  });

  /* ---------- quick view modal ---------- */
  var modalBackdrop = $(".modal-backdrop");
  var lastFocus = null;

  function openQuickView(card) {
    var jsonEl = $("[data-product-json]", card);
    if (!jsonEl || !modalBackdrop) return;
    var p;
    try { p = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    lastFocus = document.activeElement;

    var from = p.priceVaries ? '<span class="from">from </span>' : "";
    var media = p.image
      ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '">'
      : '<div class="img-fallback"><span class="ph-icon" aria-hidden="true">⬢</span><span>Photo coming soon</span></div>';
    var chip = p.material ? ' <span class="mat-chip">' + escapeHtml(p.material) + "</span>" : "";
    var action;
    if (p.quoteOnly || !p.singleVariant) {
      action = '<a class="btn btn-primary btn-block" href="' + p.url + '">' + (p.quoteOnly ? "Request a Quote" : "Choose Options") + "</a>";
    } else if (!p.available) {
      action = '<button type="button" class="btn btn-outline btn-block" disabled>Sold Out</button>';
    } else {
      action = '<button type="button" class="btn btn-primary btn-block" data-add="' + p.variantId + '">Add to Cart — ' + formatMoney(p.price) + "</button>";
    }

    $(".modal-content", modalBackdrop).innerHTML =
      '<div class="product-media">' + media + "</div>" +
      '<div class="modal-info">' +
        "<h3>" + escapeHtml(p.title) + "</h3>" +
        '<p class="product-meta"><span class="price">' + from + formatMoney(p.price) + "</span>" + chip + "</p>" +
        "<p>" + escapeHtml(p.description) + "</p>" +
        '<p class="stock-note">✓ Prints to order — ships in 3–5 business days</p>' +
        action +
        '<p class="modal-note"><a href="' + p.url + '">View full details →</a></p>' +
      "</div>";
    modalBackdrop.classList.add("open");
    $(".modal-close", modalBackdrop).focus();
  }

  function closeQuickView() {
    if (!modalBackdrop) return;
    modalBackdrop.classList.remove("open");
    if (lastFocus) lastFocus.focus();
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-add], [data-quickview], [data-line-inc], [data-line-dec], .cart-btn, [data-cart-close], .modal-close");
    if (!t) {
      if (e.target === modalBackdrop) closeQuickView();
      return;
    }
    if (t.hasAttribute("data-add")) {
      var variantId = parseInt(t.getAttribute("data-add"), 10);
      t.disabled = true;
      addToCart(variantId, 1)
        .then(function () { return getCart(); })
        .then(function (cart) {
          renderDrawer(cart);
          toast(strings.addedToCart || "Added to cart");
          closeQuickView();
          openCart();
        })
        .catch(function (err) { toast(err.message || "Couldn't add to cart"); })
        .then(function () { t.disabled = false; });
    }
    else if (t.hasAttribute("data-quickview")) openQuickView(t.closest("[data-product-card]"));
    else if (t.hasAttribute("data-line-inc")) bumpLine(t.getAttribute("data-line-inc"), 1);
    else if (t.hasAttribute("data-line-dec")) bumpLine(t.getAttribute("data-line-dec"), -1);
    else if (t.classList.contains("cart-btn")) openCart();
    else if (t.hasAttribute("data-cart-close")) closeCart();
    else if (t.classList.contains("modal-close")) closeQuickView();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeQuickView(); closeCart(); }
  });

  /* ================================================================
     Collection page — client-side search / material filter / sort
     (ported from shop.js; operates on server-rendered cards)
     ================================================================ */
  (function initCollectionFilters() {
    var root = $("[data-collection-root]");
    if (!root) return;
    var grid = $("[data-product-grid]", root);
    if (!grid) return;
    var cards = $all("[data-product-card]", grid);
    var searchInput = $("[data-grid-search]", root);
    var sortSelect = $("[data-grid-sort]", root);
    var chips = $all(".chip[data-material]", root);
    var countEl = $("[data-results-count]", root);
    var noMatches = $("[data-no-matches]", grid);

    var state = { q: "", material: "all", sort: "featured" };

    function apply() {
      var visible = [];
      cards.forEach(function (card) {
        var name = (card.getAttribute("data-name") || "").toLowerCase();
        var desc = card.querySelector(".product-desc");
        var haystack = name + " " + (desc ? desc.textContent.toLowerCase() : "");
        var material = (card.getAttribute("data-material") || "").toUpperCase();
        var okQ = !state.q || haystack.indexOf(state.q) !== -1;
        var okM = state.material === "all" || material.indexOf(state.material.toUpperCase()) !== -1;
        var show = okQ && okM;
        card.hidden = !show;
        if (show) visible.push(card);
      });

      var sorted = visible.slice();
      if (state.sort === "price-asc") sorted.sort(function (a, b) { return a.getAttribute("data-price") - b.getAttribute("data-price"); });
      else if (state.sort === "price-desc") sorted.sort(function (a, b) { return b.getAttribute("data-price") - a.getAttribute("data-price"); });
      else if (state.sort === "name") sorted.sort(function (a, b) { return a.getAttribute("data-name").localeCompare(b.getAttribute("data-name")); });
      else sorted.sort(function (a, b) { return b.getAttribute("data-featured") - a.getAttribute("data-featured"); });
      sorted.forEach(function (card) { grid.appendChild(card); });

      if (noMatches) {
        noMatches.hidden = visible.length !== 0;
        grid.appendChild(noMatches);
      }
      if (countEl) countEl.textContent = visible.length + " of " + cards.length + " products";
    }

    if (searchInput) {
      searchInput.addEventListener("input", function () {
        state.q = searchInput.value.trim().toLowerCase();
        apply();
      });
    }
    if (sortSelect) {
      sortSelect.addEventListener("change", function () { state.sort = sortSelect.value; apply(); });
    }
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
        chip.setAttribute("aria-pressed", "true");
        state.material = chip.getAttribute("data-material");
        apply();
      });
    });

    apply();
  })();

  /* ---------- newsletter client-side validation ---------- */
  $all(".newsletter-form").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      var input = form.querySelector('input[type="email"]');
      var msg = form.querySelector(".form-msg");
      var email = input ? input.value.trim() : "";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        e.preventDefault();
        if (msg) { msg.textContent = "Please enter a valid email address."; msg.className = "form-msg err"; }
        if (input) input.focus();
      }
      // Valid emails submit natively to Shopify's customer form endpoint.
    });
  });

  /* ---------- cart page quantity inputs ---------- */
  $all("[data-line-qty]").forEach(function (input) {
    input.addEventListener("change", function () {
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) return;
      changeLine(input.getAttribute("data-line-qty"), qty)
        .then(function () { window.location.reload(); })
        .catch(function (err) { toast(err.message); });
    });
  });

  // Initial badge/progress sync (covers back-button bfcache staleness)
  refreshCart();
})();
